import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { formatPriceAny, getCurrencyLabel } from 'helper/CurrencyHelper';
import i18n from 'i18n';
import styles from './campaignBidPriceInfo.module.scss';

export const renderBidPriceInfo = (
  campaign: {
    id: number;
    bidPrice?: number;
    adminBidPrice?: number;
  },
  currency: string
): any => {
  // bidPrice 用 == null：0 是合法的出價上限，不是「沒有資料」。
  // 底下 adminBidPrice 的判斷刻意維持 falsy（`!`）—— 天神模式寫入端是
  // `adminBidPrice || null`，0 代表「未調整」，改成 == null 會顯示 NTD 0 ＋驚嘆號。
  if (campaign.bidPrice == null) {
    return i18n.t('common.labels.noData');
  }

  const currencyLabel = getCurrencyLabel(currency);

  if (!campaign.adminBidPrice) {
    return `${currencyLabel} ${formatPriceAny(campaign.bidPrice)}`;
  }
  return (
    <div className={styles.bidPriceInfo}>
      <span className={styles.bidPriceLabel}>
        {`${currencyLabel} ${formatPriceAny(+campaign.adminBidPrice)}`}
      </span>
      <IconWithTooltip
        icon={faExclamationCircle}
        tooltipProps={{
          id: `bidPrice-${campaign.id}`,
          tooltip: (
            <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>
              {i18n.t('campaignList.labels.bidPriceChange', {
                from: `${currencyLabel}${campaign.bidPrice}`,
                to: `${currencyLabel}${campaign.adminBidPrice}`
              })}
            </div>
          )
        }}
      />
    </div>
  );
};
